import * as ReactQuery from 'react-query';
import { Routing } from 'global/routing';
import {
  removeRefreshToken,
  setAccessToken,
  setRefreshToken,
  removeAuthProvider,
} from 'utils/auth';
import { Services } from 'services';
import { refreshAuth0SsoAccessTokenAPI } from './api';

const AUTH0_SSO_REFRESH_TOKEN_KEY = '@auth/auth0-sso-refresh-access-token';

export function useAuth0SsoRefreshAccessToken() {
  const { isLoading, isError, isSuccess } = ReactQuery.useQuery(
    AUTH0_SSO_REFRESH_TOKEN_KEY,
    refreshAuth0SsoAccessTokenAPI,
    {
      onSuccess: (data) => {
        setAccessToken(data.id_token);
        setRefreshToken(data.refresh_token);
      },
      onError: () => {
        if (navigator.onLine) {
          removeRefreshToken();
          removeAuthProvider();
          window.location.href = Routing.LOGIN.getPath();
        }
      },
      refetchInterval: 180000,
      refetchIntervalInBackground: true,
      refetchOnReconnect: true,
      staleTime: 920000,
    }
  );

  const siteEmployeeService = Services.SiteEmployees.useGetCurrentSiteEmployee({
    enabled: isSuccess,
  });

  return {
    isLoading: isLoading || siteEmployeeService.isLoading,
    isError,
  };
}
